var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcceptancecriteria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5956_57751)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.560547,
    width: 23,
    height: 23,
    rx: 5,
    fill: "#002060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4974 13.0187C12.0267 13.0187 12.4557 12.5897 12.4557 12.0604C12.4557 11.5311 12.0267 11.1021 11.4974 11.1021C10.9681 11.1021 10.5391 11.5311 10.5391 12.0604C10.5391 12.5897 10.9681 13.0187 11.4974 13.0187Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 12.0607C6.71094 13.0084 6.99196 13.9348 7.51848 14.7228C8.04499 15.5108 8.79335 16.125 9.66891 16.4876C10.5445 16.8503 11.5079 16.9452 12.4374 16.7603C13.3669 16.5754 14.2207 16.1191 14.8908 15.4489C15.561 14.7788 16.0173 13.925 16.2022 12.9955C16.3871 12.066 16.2922 11.1026 15.9295 10.227C15.5669 9.35146 14.9527 8.6031 14.1647 8.07658C13.3767 7.55007 12.4503 7.26904 11.5026 7.26904",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 18.7277C7.09998 19.6048 8.36391 20.2121 9.7165 20.4985C11.0691 20.7849 12.4707 20.7419 13.8032 20.3732C15.1357 20.0044 16.3601 19.3208 17.373 18.3798C18.386 17.4389 19.1579 16.2682 19.6237 14.9664C20.0896 13.6647 20.2356 12.2701 20.0496 10.9C19.8635 9.53004 19.3509 8.22483 18.5548 7.09443C17.7588 5.96403 16.7026 5.04157 15.4754 4.4048C14.2482 3.76802 12.8859 3.4356 11.5033 3.43555",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5956_57751"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.560547,
    width: 23,
    height: 23,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptancecriteria);
export default __webpack_public_path__ + "static/media/acceptancecriteria.e78d4982368363f305da2bfec241c8f0.svg";
export { ForwardRef as ReactComponent };